<template>
    <div id="packer_current_pack">
        <div class="ui card">
            <div class="content">
                <h2 class="ui header">
                    <i class="info circle icon"></i>
                    <div class="content">
                        目前包裹
                    </div>
                </h2>
            </div>
            <div class="content">
                <div v-if="Object.keys(current_pack).length > 0">
                    <table class="ui celled table">
                        <thead>
                            <tr>
                                <th class="six wide center aligned">欄位</th>
                                <th class="ten wide center aligned">內容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="center aligned">號碼</td>
                                <td class="center aligned">{{ current_pack.core_waybill_number }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <h3 class="ui header">包裹內容</h3>
                    <table class="ui celled table">
                        <thead>
                            <tr>
                                <th class="six wide center aligned">序號</th>
                                <th class="ten wide center aligned">運單號</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="center aligned"></td>
                                <td class="center aligned"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="ui icon message">
                    <i class="question icon"></i>
                    <div class="content">
                        <div class="header">
                            尚未選擇任何包
                        </div>
                        <p>點選"{{ $t("packer.show") }}"開始作業</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        current_pack: Object,
    },
    data: function() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
    },
    components: {
    }
}
</script>
